/**
 * Sprint 19 B1-B2: AMP Email Components
 *
 * 6 interactive AMP components for Gmail/Yahoo/Mail.ru.
 * Each generates AMP HTML + standard HTML fallback.
 *
 * AMP4Email spec: https://amp.dev/documentation/guides-and-tutorials/learn/email-spec/amp-email-format/
 */

export const AMP_COMPONENT_TYPES = [
  "amp_booking",
  "amp_poll",
  "amp_carousel",
  "amp_accordion",
  "amp_nps",
  "amp_preferences",
] as const;

export type AmpComponentType = (typeof AMP_COMPONENT_TYPES)[number];

export interface AmpComponentConfig {
  type: AmpComponentType;
  label: string;
  icon: string;
  defaultProps: Record<string, unknown>;
  /** AMP script URL required in <head> */
  ampScript: string;
}

export const AMP_COMPONENT_REGISTRY: AmpComponentConfig[] = [
  {
    type: "amp_booking",
    label: "Booking Calendar",
    icon: "calendar",
    defaultProps: { serviceId: "", slots: [], buttonText: "Book Now" },
    ampScript: "https://cdn.ampproject.org/v0/amp-list-0.1.js",
  },
  {
    type: "amp_poll",
    label: "Interactive Poll",
    icon: "bar-chart",
    defaultProps: { question: "What do you think?", options: ["Great", "Good", "Needs work"], showResults: true },
    ampScript: "https://cdn.ampproject.org/v0/amp-form-0.1.js",
  },
  {
    type: "amp_carousel",
    label: "Image Carousel",
    icon: "images",
    defaultProps: { images: [], autoplay: true, delay: 3000 },
    ampScript: "https://cdn.ampproject.org/v0/amp-carousel-0.2.js",
  },
  {
    type: "amp_accordion",
    label: "Accordion / FAQ",
    icon: "chevrons-down",
    defaultProps: { sections: [{ title: "Question 1", content: "Answer 1" }], expandFirst: true },
    ampScript: "https://cdn.ampproject.org/v0/amp-accordion-0.1.js",
  },
  {
    type: "amp_nps",
    label: "NPS Rating (1-10)",
    icon: "star",
    defaultProps: { question: "How likely are you to recommend us?", submitEndpoint: "" },
    ampScript: "https://cdn.ampproject.org/v0/amp-form-0.1.js",
  },
  {
    type: "amp_preferences",
    label: "Preference Center",
    icon: "settings",
    defaultProps: { categories: ["Newsletter", "Product Updates", "Promotions"], submitEndpoint: "" },
    ampScript: "https://cdn.ampproject.org/v0/amp-form-0.1.js",
  },
];
